import { getRequest, IApiResponse } from "../../service/Basevices";
import { IResGetDataDashboard } from "./Interface";

export const getDataDashboardAPI = (startDate: string, endDate: string): Promise<IApiResponse<IResGetDataDashboard>> => {
  let path: string = `/home/summary`;
  startDate && (path = path + `?start_date=${startDate}`);
  endDate && (path = path + `&end_date=${endDate}`);
  return getRequest(path, true, );
};